/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Cool_Swift_Hawk_SoarInputs */

const en_cool_swift_hawk_soar = /** @type {(inputs: Cool_Swift_Hawk_SoarInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} configured`)
};

const de_cool_swift_hawk_soar = /** @type {(inputs: Cool_Swift_Hawk_SoarInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} konfiguriert`)
};

/**
* | output |
* | --- |
* | "{count} configured" |
*
* @param {Cool_Swift_Hawk_SoarInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cool_swift_hawk_soar = /** @type {((inputs: Cool_Swift_Hawk_SoarInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cool_Swift_Hawk_SoarInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cool_swift_hawk_soar(inputs)
	return de_cool_swift_hawk_soar(inputs)
});